import { uploadRoomFile, getRoomFileUrl } from "../lib/roomFileStorage";

const FUNCTION_URL = process.env.REACT_APP_GPT_IMAGE_URL || "";
const ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isConfigured = () => Boolean(FUNCTION_URL);

export async function generateImage({ prompt, context, userId, whiteboardId }) {
  if (!FUNCTION_URL) {
    return { ok: false, error: "Image generation is not switched on yet." };
  }

  try {
    const res = await fetch(FUNCTION_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ANON_KEY}`,
      },
      body: JSON.stringify({ prompt, context, userId, whiteboardId }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data?.image) {
      return {
        ok: false,
        error: data?.error || `Could not generate that (${res.status}).`,
        capReached: Boolean(data?.capReached),
        used: data?.used,
        cap: data?.cap,
      };
    }
    return { ok: true, image: data.image, prompt: data.prompt, caption: data.caption || null, used: data.used, cap: data.cap };
  } catch (err) {
    console.warn("[whiteboard] image generation failed:", err?.message || err);
    return { ok: false, error: "Could not reach the image service." };
  }
}

export async function persistGeneratedImage(dataUrl, userId, roomId) {
  if (!dataUrl || !userId || !roomId) return { src: dataUrl, storagePath: null };
  try {
    const blob = await (await fetch(dataUrl)).blob();
    const file = new File([blob], `generated-${Date.now()}.png`, { type: "image/png" });
    const { storagePath } = await uploadRoomFile(userId, roomId, file);
    const src = await getRoomFileUrl(storagePath);
    return { src, storagePath };
  } catch (err) {
    console.warn("[whiteboard] could not store the generated image:", err?.message || err);
    return { src: dataUrl, storagePath: null };
  }
}

const imageGenerationService = { generateImage, persistGeneratedImage, isConfigured };
export default imageGenerationService;
